import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { dateTimeFormat } from "utils/helpers/date";
import type { SimpleTableColumn } from "components/shared/tables/SimpleTable";

export const useColumns = ({ dateFormat }: { dateFormat: string }) => {
    const { t } = useTranslation();

    return useMemo<SimpleTableColumn<any>[]>(() => [
        {
            header: t("type"),
            cell: (row) => (row.type ? t(row.type.toLowerCase()) : null),
        },
        {
            header: t("start-date"),
            cell: (row) => dateTimeFormat(row.startDate, dateFormat),
        },
        {
            header: t("end-date"),
            cell: (row) => dateTimeFormat(row.endDate, dateFormat),
        },
        {
            header: t("total"),
            cell: (row) => Number(row.total).toFixed(2),
        },
    ], [t, dateFormat]);
};
